<div class="user-photo" [ngStyle]="userPhotoStyle$ | async"></div>